import { Injectable } from '@angular/core';
import { Menu } from 'src/app/_models';

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  menu: Menu[] = [];
  constructor() {
    this.menuInit();
  }
  menuInit() {
    this.menu = [
      {
        id: 1,
        image: '../../../assets/Icons/attach-1@2x.png',
        imageHover: '../../../assets/Icons/attach-1@2x.png',
        name: 'Diary',
        mainRouteName: 'students/diary',
        routerUrl: 'diary',
        isHover: false
      },
      {
        id: 2,
        image: '../../../assets/Icons/education-2_2.png',
        imageHover: '../../../assets/Icons/education-2@2x.png',
        name: 'Communications',
        mainRouteName: 'students/communications',
        routerUrl: 'overview',
        isHover: false
      },
      {
        id: 3,
        image: '../../../assets/Icons/education-2_2.png',
        imageHover: '../../../assets/Icons/education-2@2x.png',
        name: 'SocialLearning',
        mainRouteName: 'students/social-learning',
        routerUrl: 'social-learning',
        isHover: false
      },
      {
        id: 4,
        image: '../../../assets/Icons/event-2_2.png',
        imageHover: '../../../assets/Icons/event-2.png',
        name: 'Event',
        mainRouteName: 'students/event',
        routerUrl: 'event',
        isHover: false
      },
      {
        id: 4,
        image: '../../../assets/Icons/notebook-2.png',
        imageHover: '../../../assets/Icons/notebook-2@2x.png',
        name: 'Directory',
        mainRouteName: null,
        routerUrl: null,
        isHover: false
      },
      {
        id: 5,
        image: '../../../assets/Icons/archive-2.png',
        imageHover: '../../../assets/Icons/archive-2.png',
        name: 'Votes',
        mainRouteName: 'students/votes',
        routerUrl: 'votes',
        isHover: false
      },
      {
        id: 6,
        image: '../../../assets/Icons/family-tree-1.png',
        imageHover: '../../../assets/Icons/family-tree-1@2x.png',
        name: 'Clubs&Family',
        mainRouteName: null,
        routerUrl: null,
        isHover: false
      },
      {
        id: 7,
        image: '../../../assets/Icons/flag@2x.png',
        imageHover: '../../../assets/Icons/flag@2x.png',
        name: 'Competitions',
        mainRouteName: null,
        routerUrl: null,
        isHover: false
      },
      {
        id: 9,
        image: '../../../assets/Icons/group-3.png',
        imageHover: '../../../assets/Icons/group-3@2x.png',
        name: 'Support',
        mainRouteName: null,
        routerUrl: null,
        isHover: false
      },
      {
        id: 10,
        image: '../../../assets/Icons/share-1@2x.png',
        imageHover: '../../../assets/Icons/share-1@2x.png',
        name: 'Honors',
        mainRouteName: null,
        routerUrl: null,
        isHover: false
      }
    ];
  }
}
